document.addEventListener('DOMContentLoaded',()=>{
  const toggle=document.querySelector('[data-menu-toggle]');
  const drawer=document.querySelector('[data-menu-drawer]');
  if(toggle&&drawer){toggle.addEventListener('click',()=>{const open=drawer.classList.toggle('is-open');toggle.setAttribute('aria-expanded',String(open));});}
  document.querySelectorAll('[data-product-form]').forEach(form=>{
    const price=form.querySelector('[data-price]');
    form.querySelectorAll('input[name="id"]').forEach(input=>input.addEventListener('change',()=>{if(price&&input.dataset.price)price.textContent=input.dataset.price;}));
    const qty=form.querySelector('input[name="quantity"]');
    form.querySelector('[data-minus]')?.addEventListener('click',()=>{qty.value=Math.max(1,Number(qty.value||1)-1);});
    form.querySelector('[data-plus]')?.addEventListener('click',()=>{qty.value=Number(qty.value||1)+1;});
  });
});
